Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var container = {
    borderWidth: (0, _styles.getREM)(0.125),
    borderStyle: 'solid',
    borderColor: COLORS.steam,
    borderRadius: (0, _styles.getREM)(0.625),
    flexDirection: bp.not([bp.tablet, bp.desktop]) ? 'column' : 'row',
    justifyContent: 'space-between',
    paddingVertical: spacing.l,
    paddingHorizontal: spacing.xl,
    marginBottom: spacing.l
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    container.paddingVertical = spacing.s;
    container.paddingHorizontal = spacing.s;
  }
  if (bp.desktop) {
    container.paddingVertical = spacing.xxl;
    container.paddingHorizontal = spacing.xxxl;
  }
  var description = {
    width: 'auto',
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    flexShrink: 1
  };
  var name = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m,
    color: COLORS.aubergine,
    marginBottom: (0, _styles.getREM)(0.625)
  });
  var message = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  var toggle = {
    marginTop: (0, _styles.getREM)(1.25),
    paddingLeft: 0,
    alignSelf: 'center'
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    toggle.paddingLeft = (0, _styles.getREM)(3.125);
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    description: description,
    name: name,
    message: message,
    toggle: toggle
  });
  return {
    styles: styles
  };
};